import {Component, Input, OnInit} from '@angular/core';

@Component({
  selector: 'app-loading',
  templateUrl: './loading.component.html',
  styleUrls: ['./_loading.component.scss']
})
export class LoadingComponent implements OnInit {
  @Input() public classes: string;

  constructor() {}

  ngOnInit() {}
}
